export default __webpack_public_path__ + "static/media/paperOS_capital_at_scale_white_lg.ffea02a6.png";